import { use, useEffect, useRef, useState } from "react";
import FormDropDown from "../../../forms/DropDownList/FormDropDown";
import "./TriviaSelector.scss";
import { VAR_TYPES } from "../../../../config/FeatureDashboardVarMap";

const TriviaSelector = (props) => {
    console.log('--- TriviaSelector, props: ', props);

    const passedInPreviewData = props?.passedInPreviewData;
    const featureVars_top = passedInPreviewData ? passedInPreviewData : props.featureVars;
    const roundsCount = props?.customisationData?.setup?.triviaData?.triviaSetup?.[0]?.roundsCount ?? 1;
    let selectedRound_top = featureVars_top.triviaControl?.selectedRound ?? passedInPreviewData?.triviaControl?.selectedRound ?? 0;
    if (isNaN(selectedRound_top) || selectedRound_top < 0 || selectedRound_top >= roundsCount) {
        selectedRound_top = 0;
    }

    // Build our drop down options from props.customisationData.setup.triviaData.questions[i].title
    const triviaListData = [];
    for (let i = 0; i < roundsCount; i++) {
        const roundQuestionsData = props.customisationData?.setup?.['triviaData' + (i + 1)]?.questions;
        const roundQuestions = [];
        triviaListData.push(roundQuestions);
        if (roundQuestionsData && roundQuestionsData.length > 0) {
            for (let j = 0; j < roundQuestionsData.length; j++) {
                roundQuestions.push({
                    id: roundQuestions.length,
                    label: roundQuestionsData[j].title,
                    value: roundQuestions.length,
                    val: roundQuestions.length
                });
            }
        } else {
            roundQuestions.push({
                id: 0,
                label: "No Questions Available",
                value: 0,
                val: 0
            });
        }
    }

    useEffect(() => {
        if (typeof props.value !== 'number' || props.value < 0 || props.value >= triviaListData?.[selectedRound_top]?.length) {
            console.log('--- TriviaSelector, useEffect invalid index, resetting to 0: ', props.value);
            props.setFunc(0);
            return;
        }

        console.log('--- TriviaSelector, useEffect: ', props, triviaListData);
        
        // Does the selected question have any votes?
        const featureVars = props.passedInPreviewData ? props.passedInPreviewData : props.featureVars;
        console.log('--- TriviaSelector, used featureVars: ', featureVars, props.customisationData?.setup?.['triviaData' + selectedRound_top]?.questions?.[props.value]);
        let triviaStateData = null;
        if (featureVars?.triviaControl?.triviaState) {
            for (let i = 0; i < featureVars.triviaControl.triviaState.length; i++) {
                if (featureVars.triviaControl.triviaState[i].triviaTitle === props.customisationData?.setup?.['triviaData' + selectedRound_top]?.questions?.[props.value]?.title) {
                    triviaStateData = featureVars.triviaControl.triviaState[i];
                    break;
                }
            }
        }
        let triviaHasVotes = false;
        if (triviaStateData && triviaStateData.answerState && triviaStateData.answerState.length > 0) {
            for (let i = 0; i < triviaStateData.answerState.length; i++) {
                if (triviaStateData.answerState[i].votePercentage > 0) {
                    triviaHasVotes = true;
                }
            }
        }

        console.log('--- TriviaSelector, triviaData: ', triviaStateData, triviaHasVotes);

        props.changeValFunc('triviaControl', 'triviaHasVotes', triviaHasVotes, false, false, false);

    }, [props.value]);

    // onMount - make sure we have these values!
    useEffect(() => {
        if (props.featureVars.triviaControl.triviaRunning !== true && props.featureVars.triviaControl.triviaRunning !== false) {
            props.changeValFunc('triviaControl', 'triviaRunning', false, false, false, false);
        }
        if (props.featureVars.triviaControl.triviaVisible !== true && props.featureVars.triviaControl.triviaVisible !== false) {
            props.changeValFunc('triviaControl', 'triviaVisible', false, false, false, false);
        }
        // Ensure we have a valid trivia index
        let correctTriviaIndex = props.value;
        if (isNaN(correctTriviaIndex) || correctTriviaIndex < 0 || correctTriviaIndex >= triviaListData?.[selectedRound_top]?.length) {
            correctTriviaIndex = 0;
        }
        if (correctTriviaIndex !== props.value) {
            props.setFunc(correctTriviaIndex);
        }

        // Does the selected trivia have any votes?
        const featureVars = props.passedInPreviewData ? props.passedInPreviewData : props.featureVars;
        let triviaData = null;
        if (featureVars?.triviaControl?.triviaState && featureVars.triviaControl.triviaState?.[selectedRound_top]?.length) {
            for (let i = 0; i < featureVars.triviaControl.triviaState[selectedRound_top].length; i++) {
                if (featureVars.triviaControl?.triviaState?.[selectedRound_top]?.[i]?.triviaTitle === props.customisationData?.setup?.['triviaData' + selectedRound_top]?.questions?.[props.value]?.title) {
                    triviaData = featureVars.triviaControl.triviaState[selectedRound_top][i];
                    break;
                }
            }
        }
        let triviaHasVotes = false;
        if (triviaData && triviaData.answerState && triviaData.answerState.length > 0) {
            for (let i = 0; i < triviaData.answerState.length; i++) {
                if (triviaData.answerState[i].votePercentage > 0) {
                    triviaHasVotes = true;
                }
            }
        }

        // These false, false, false flags are to prevent the changeValFunc from reporting a change and also rebuilding state data
        // we're doing this because we only need to report changes and update state once all these values have changed.
        // The final true, false, false flag tells the dashboard to report the changes, but still hold off on rebuilding state data
        // this is because the state data will get rebuilt anyway after the data is reported - if we use default behaviour we get some thrashing
        // of the state and our button flickers between states, this ensures we only update the state once.

        console.log('--- LiveTriviaSelector, triviaData: ', triviaData, triviaHasVotes);

        props.changeValFunc('triviaControl', 'triviaHasVotes', triviaHasVotes, false, false, false);

        props.sendFeatureCommandFunc(null, 'REQUEST_SYNC', props.featureId, 0)
    }, []);

    const featureVars = props.passedInPreviewData ? props.passedInPreviewData : props.featureVars;

    const getRoundList = () => {
        const roundList = [];
        if (roundsCount) {
            for (let i = 0; i < roundsCount; i++) {
                roundList.push({
                    id: i,
                    label: props.customisationData?.setup?.['triviaData' + (i + 1)]?.roundSetup?.[0]?.roundName ?? `Round ${i + 1}`,
                    value: i,
                    val: i
                });
            }
        }
        return roundList;
    }

    const getRoundQuestionsList = (forceRound = null) => {
        console.log('--- LiveTriviaSelector, triviaListData: ', triviaListData, selectedRound_top, forceRound);
        const varsToUse = featureVars;
        console.log('varsToUse: ', varsToUse);
        const questionsList = [];
        if (triviaListData.length > 0/* varsToUse?.triviaControl?.roundSetup && varsToUse.triviaControl.roundSetup.length > 0 */) {
            const roundIndex = forceRound !== null ? forceRound : varsToUse.triviaControl.selectedRound ?? 0;
            if (triviaListData[roundIndex] && triviaListData[roundIndex].length > 0 /* varsToUse.triviaControl.roundSetup[roundIndex] && varsToUse.triviaControl.roundSetup[roundIndex].length > 0 */) {
                for (let i = 0; i < triviaListData[roundIndex].length; i++) {
                    questionsList.push({
                        id: i,
                        label: triviaListData[selectedRound_top][i].label,
                        questionIndex: i,
                        value: i,
                        val: i
                    });
                }
            }
        }
        return questionsList;
    }

    return (
        <>
                <div className="fl-column">
                    <FormDropDown
                        label={'Select Round'}
                        items={getRoundList()}
                        value={selectedRound_top}
                        selectFunc={
                            (e, id, item) => {
                                props.changeValFunc('triviaControl', 'selectedRound', item.value, false, false, false);
                                props.changeValFunc('triviaControl', 'currentRoundQuestionIndex', 0, false, false, false, VAR_TYPES.numberType);
                                props.setFunc(getRoundQuestionsList(item.value)[0]?.questionIndex ?? 0);
                            }
                        }
                        currentIndex={Number(selectedRound_top)}
                        showErrors={false}
                        enabled={triviaListData.length > 1 && !featureVars_top?.triviaControl?.triviaVisible}
                    />
                    <div className="fl-row bold-text small-text confirm-text">
                        {`${triviaListData[selectedRound_top]?.length ?? 0} questions in this round`}
                    </div>
                    <FormDropDown
                        label={'Select Question'}
                        items={getRoundQuestionsList(selectedRound_top)}
                        value={Number(featureVars?.triviaControl?.currentRoundQuestionIndex ?? 0)}
                        selectFunc={
                            (e, id, item) => {
                                props.changeValFunc('triviaControl', 'currentRoundQuestionIndex', item.value, false, false, false, VAR_TYPES.numberType);
                                props.setFunc(item.questionIndex);
                            }
                        }
                        currentIndex={Number(featureVars?.triviaControl?.currentRoundQuestionIndex ?? 0)}
                        showErrors={false}
                        enabled={triviaListData[selectedRound_top]?.length > 1 && !featureVars_top?.triviaControl?.triviaVisible}
                    />
                </div>
        </>
    )
};

export default TriviaSelector;
